'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagBnAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-5.24521e-06 2C-5.24521e-06 0.895431 0.895425 0 1.99999 0H26C27.1046 0 28 0.89543 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895426 20 -5.24521e-06 19.1046 -5.24521e-06 18V2Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M-5.24521e-06 0H28V20H-5.24521e-06V0Z", fill: "#F7E250" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-7.62939e-05 4.99999L27.9999 15.5V11L-7.62939e-05 0.499995V4.99999Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-7.62939e-05 9L27.9999 19.5V15.5L-7.62939e-05 4.99999V9Z",
          fill: "#262626"
        }
      )
    ]
  }
);
const VpFlagBnAsset = forwardRef(FlagBnAsset);

export { VpFlagBnAsset as default };
